// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"db14cd74","662":"e62fde3d","772":"f979f665","825":"7705533d"}[chunkId] + ".chunk.js";
};